<footer class="l-footer">
  <div class="l-footer_sup">
    <div class="l-container">
      <div class="l-footer_grid">
        <div class="l-footer_grid_item">
          <ul class="l-footer_iconList" data-list="1">
            <li class="" *ngFor="let social of listIcons">
              <a href="l-footer_iconList_icon">
                <svg class="c-icon--xs">
                  <use [attr.xlink:href]="social.icon" />
                </svg>
              </a>
            </li>
          </ul>
          <img alt="Logo VinhoBid" class="l-footer_logo" src="./assets/images/icons/ic-bottle.svg" />
        </div>
        <div class="l-footer_grid_item">
          <h4 class="m-titleSimple--fixedSize">A VinhoBid</h4>
          <ul class="l-footer_list">
            <li class="l-footer_list_item">
             <a class="clickable-link" (click)="onRouteClick('Quem somos', '/quem-somos')">Quem somos</a>
            </li>
            <li class="l-footer_list_item">
              <a class="clickable-link" (click)="onRouteClick('Os especialistas', '/os-especialistas')">Os especialistas</a>
            </li>
          </ul>
        </div>
        <div class="l-footer_grid_item">
          <h4 class="m-titleSimple--fixedSize">Políticas e termos</h4>
          <ul class="l-footer_list">
            <li class="l-footer_list_item">
              <a class="clickable-link" (click)="onRouteClick('Políticas do comprador', '/politicas-comprador')">Políticas do comprador</a>
            </li>
            <li class="l-footer_list_item">
              <a class="clickable-link" (click)="onRouteClick('Políticas do vendedor', '/politicas-vendedor')">Políticas do vendedor</a>
            </li>
            <li class="l-footer_list_item">
              <a class="clickable-link" (click)="onRouteClick('Termos e condições', '/termos-condicoes')">Termos e condições</a>
            </li>
          </ul>
        </div>
        <div class="l-footer_grid_item">
          <h4 class="m-titleSimple--fixedSize">Ajuda</h4>
          <ul class="l-footer_list">
            <li class="l-footer_list_item">
              <a class="clickable-link" (click)="onRouteClick('Perguntas frequentes', '/perguntas-frequentes')">Perguntas frequentes</a>
            </li>
            <li class="l-footer_list_item">
              <!-- <a routerLink="/contato">Contato</a> -->
              <a href="JavaScript:void(0);" (click)="window.FrontChat('show')">Contato</a>
            </li>
          </ul>
        </div>
        <div class="l-footer_grid_item">
          <ul class="l-footer_iconList" data-list="2">
            <li class="" *ngFor="let social of listIcons">
              <a [href]="social.link" class="">
                <svg class="l-footer_iconList_icon c-icon--xs">
                  <use [attr.xlink:href]="social.icon" />
                </svg>
              </a>
            </li>
          </ul>
          <ul class="l-footer_list">
            <li class="l-footer_list_item">
              <a href="mailto:contato@vinhobid.com" target="_blank">
                <svg class="c-icon--xxs">
                  <use xlink:href="#ic-mail" />
                </svg>
                contato&#64;vinhobid.com</a>
            </li>
            <li class="l-footer_list_item">
              <a (click)="onRouteClick('Whatsapp', 'https://wa.me/5511994259485')" href="https://wa.me/5511994259485" target="_blank">
                <svg class="c-icon--xxs">
                  <use xlink:href="#ic-whatsapp" />
                </svg>
                (11) 99425-9485
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="l-container">
    <div class="l-footer_sub">
      <p class="m-paragraph--small s-fontWeight--light">A venda de bebidas alcoólicas é proibida para menores de 18 anos. Aprecie com moderação. Se beber, não dirija.</p>
      <p class="m-paragraph--small">© 2020. VinhoBid S.A. - CNPJ: 34.062.543/0001-55. Rua Cap Antonio Rosa, 409 - Jardim Paulistano, São Paulo - SP. Todos os direitos reservados. Conheça nossa <a routerLink="/politica-de-privacidade">política de privacidade</a> e <a routerLink="/politica-de-cookies">política de cookies</a>.</p>
    </div>
  </div>
</footer>
